module.exports = __webpack_public_path__ + "static/media/marker2.c4f943ea.svg";